import type { Database } from '@familychef/db';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env['VITE_SUPABASE_URL'] as string;
const supabasePublishableKey = import.meta.env['VITE_SUPABASE_PUBLISHABLE_KEY'] as string;

if (!supabaseUrl || !supabasePublishableKey) {
  throw new Error('Missing Supabase environment variables');
}

/**
 * Module-level token getter, registered by AuthProvider once Clerk is ready.
 */
let _clerkGetToken: (() => Promise<string | null>) | null = null;

export function setClerkTokenGetter(getter: () => Promise<string | null>) {
  _clerkGetToken = getter;
}

// Auth is managed by Clerk via Supabase Third-Party Auth integration.
// The `accessToken` callback provides the Clerk session token on every
// request — Supabase verifies it via Clerk's JWKS endpoint (RS256).
export const supabase = createClient<Database>(supabaseUrl, supabasePublishableKey, {
  accessToken: async () => {
    if (!_clerkGetToken) return '';
    return (await _clerkGetToken()) ?? '';
  },
});

export function getPublicImageUrl(bucket: string, path?: string | null): string | null {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${supabaseUrl}/storage/v1/object/public/${bucket}/${path}`;
}
